import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import {
  Box,
  Heading,
  Text,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  useToast,
} from '@chakra-ui/react';
import Card from 'components/card/Card.js';
import { getData } from 'utils/httpClient';

/*
  Vista LISTA del dictado: muestra los inscriptos al dictado :id.

  UI:
    - Tabla de inscriptos (estudiante, documento, estado de inscripción).

  Lógica de negocio:
    - Debe traer inscripciones NO dadas de baja ni eliminadas (soft delete)
      pertenecientes al dictado.
    - Endpoint usado: GET /course-inscriptions/course/:id
      (trae los student_course activos del dictado con datos de persona).
*/
export default function DictatedCourseListView() {
  const { id } = useParams();
  const [rows, setRows] = useState([]);
  const toast = useToast();

  useEffect(() => {
    const load = async () => {
      try {
        const res = await getData(`/course-inscriptions/course/${id}`);
        setRows(res?.payload?.inscriptions || []);
      } catch (error) {
        toast({
          title: 'Error al obtener inscriptos',
          description: error?.message,
          status: 'error',
          duration: 3000,
          isClosable: true,
        });
      }
    };
    if (id) load();
  }, [id, toast]);

  return (
    <Box pt={{ base: '130px', md: '80px', xl: '80px' }}>
      <Card p={5}>
        <Heading size="md" mb={4}>
          Lista de inscriptos - Dictado #{id}
        </Heading>
        {rows.length === 0 ? (
          <Text>No hay inscriptos en este dictado.</Text>
        ) : (
          <Table size="sm">
            <Thead>
              <Tr>
                <Th>Estudiante</Th>
                <Th>Documento</Th>
                <Th>Estado</Th>
              </Tr>
            </Thead>
            <Tbody>
              {rows.map((r) => (
                <Tr key={r.id}>
                  <Td>
                    {r?.student?.person?.name} {r?.student?.person?.lastName}
                  </Td>
                  <Td>{r?.student?.person?.document}</Td>
                  <Td>{r?.status || '-'}</Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        )}
      </Card>
    </Box>
  );
}
